import { render, staticRenderFns } from "./section-table-sm.vue?vue&type=template&id=41061d93&scoped=true"
import script from "./section-table-sm.vue?vue&type=script&lang=ts"
export * from "./section-table-sm.vue?vue&type=script&lang=ts"
import style0 from "./section-table-sm.vue?vue&type=style&index=0&id=41061d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41061d93",
  null
  
)

export default component.exports